module.exports = __webpack_public_path__ + "static/img/title.64cc978.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/news2/title.png
// module id = rtxl
// module chunks = 7